import { gql } from 'graphql-request';
import { graphQLClient } from '@devd-client/api';
import { getOrgId } from '@devd-client/devd/auth';
import { ContributorsDataResponse } from '../helpers/goals.types';

export const goalsGenericGraphql = async (
  metric: string,
  startDate: string,
  endDate: string,
  teamId: string,
  sprintId: string
): Promise<any> =>
  await graphQLClient.request(
    gql`
      query GetGoalMetricsByType(
        $orgId: String!
        $metric: String!
        $startDate: String!
        $endDate: String!
        $teamId: String!
        $sprintId: String
      ) {
        GoalMetricsByType(
          metric: $metric
          filter: {
            orgId: $orgId
            startDate: $startDate
            endDate: $endDate
            teamId: $teamId
            sprintId: $sprintId
          }
        ) {
          chartMetadata {
            chartType
            chartTitle
            info
            xlabel
            ylabel
            xAxis
            yAxis
            chartKey
          }
          data
          legend {
            color
            label
          }
          keys {
            key
            name
            color
          }
        }
      }
    `,
    {
      orgId: `${getOrgId()}`,
      metric,
      startDate,
      endDate,
      teamId,
      sprintId,
    }
  );

export const getContributorsData = async (
  filter: {
    teamId: string;
    startDate: string | null;
    endDate: string | null;
    contributorFilters: {
      activeFilters: { field: string; value: string } | null;
      inActiveFilters: { field: string; value: string } | null;
      excluded: 'true' | 'false';
    };
    searchTerm: string;
  },
  pageNumber: number,
  pageSize: number
): Promise<ContributorsDataResponse> => {
  return await graphQLClient.request(
    gql`
      query GetContributorsData(
        $filter: Filter
        $pageNumber: Int
        $pageSize: Int
      ) {
        ContributorsData(
          filter: $filter
          pageNumber: $pageNumber
          pageSize: $pageSize
        ) {
          data {
            email
            name
            jobRole
            teams
            avatar
            bot
            suggestedEmail
            suggestedScore
            contributorAccountList {
              key {
                orgId
                type
                account
              }
              emailId
              name
              avatar
              bot
              suggestionScore
              suggestedEmail
            }
            suggestedContributors {
              key {
                orgId
                type
                account
              }
              emailId
              name
              avatar
              bot
              suggestionScore
              suggestedEmail
            }
          }
          totalPages
          currentPage
          totalCount
        }
      }
    `,
    {
      filter: {
        ...filter,
        orgId: getOrgId(),
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      pageNumber,
      pageSize,
    }
  );
};
